import { Suspense } from 'react';
import { Tabs, useTabs } from '@common';
import {
  ClosePartnerToggle,
  CompanyDetailsHeader,
  CompanyMailButton,
} from '@features';
import { Loader } from '@mantine/core';
import { PageLayout } from '@pages';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/companies/$id';
import { tabs } from './data';
import type { CompanyDetailsActiveTab } from './data/tabs';

export const CompanyDetailsPage: React.FC = () => {
  const { t } = useTranslation('companyDetails');
  const { id } = Route.useParams();
  const { activeTab, allowedTabs } = useTabs(tabs);

  return (
    <PageLayout
      title={
        <Suspense fallback={<Loader size="xs" color="white" />}>
          <CompanyDetailsHeader />
        </Suspense>
      }
    >
      <Tabs<CompanyDetailsActiveTab> value={activeTab ?? 'general'}>
        <Tabs.TabsList>
          {allowedTabs.map((tab) => (
            <Tabs.Tab
              to={`/companies/$id/${tab.value}`}
              params={{ id }}
              key={tab.value}
              value={tab.value}
            >
              {t(`TABS.${tab.labelKey}`)}
            </Tabs.Tab>
          ))}
          {activeTab === 'general' && (
            <Tabs.TabsListActions>
              <Suspense fallback={null}>
                <ClosePartnerToggle />
                <CompanyMailButton companyId={id} />
              </Suspense>
            </Tabs.TabsListActions>
          )}
        </Tabs.TabsList>
      </Tabs>
      <Outlet />
    </PageLayout>
  );
};
